import { APP_ROUTES } from '@/shared/constants/app-routes';
import { collectAppRoutePaths } from '@/shared/functions/collect-app-route-paths';

export const PUBLIC_APP_ROUTE_PATHS = collectAppRoutePaths(APP_ROUTES.PUBLIC);
export const PRIVATE_APP_ROUTE_PATHS = collectAppRoutePaths(APP_ROUTES.PRIVATE);
